import { Box, ButtonIcon } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './styles.module.scss';

export default function DownloadButton(props) {
  return (
    <Box className={styles.downloadButtonWrapper}>
      <ButtonIcon
        variant={['primary', 'medium']}
        icon="icon-descargar"
        text={Trans(translations, 'Download')}
        className={styles.downloadButton}
        {...props}
      />
    </Box>
  );
}
